import styled from '@emotion/styled';
import * as MUI from '@mui/material';

export const Button = styled(MUI.Button)`
  color: ${({ theme }) => theme.color.white};
`;
